// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__32tgu","content":"LayoutSettings_content__2P2xS"};